import { NolBridge } from '@yanolja-org/nol-bridge';

import type { NavigationProvider } from '../types';

export const nolBridgeProvider: NavigationProvider = {
  name: 'nolBridge',
  isAvailable: () => NolBridge.isEnabled,
  navigate: (url, action) => {
    if (NolBridge.isEnabled) {
      switch (action) {
        case 'logo':
          void NolBridge.home();
          return;
        default:
          void NolBridge.openWebView({ url });
      }
    }
  },
};
